export default {
  home: {
    minute: "minuto",
    price_info:
      "Os primeiros {mianfei} minutos são gratuitos. O custo máximo por 24 horas é {currencyName}{fengding}. O power bank pode ser devolvido a qualquer estação {appName}.",
    price_info_0: 'Inclui cabo USB C e Lightning.',
    price_info_1: 'Se o power bank não for devolvido dentro de {pOvertimeDay} dias, será considerado comprado pelo valor da caução.',
    price_info_2: 'Recomendamos devolver o power bank no mesmo local onde foi alugado. Baixe o aplicativo ou leia o código QR na parte traseira do power bank para ver todos os locais {appName}.',
    feature_1: "Inclui todos os tipos de cabos: iPhone, Type-C",
    feature_2: "Pode ser devolvido em qualquer estação",
    feature_3:
      "Carregamento sem fio disponível",
    tips_1:
      "A sua caução de {currencyName}{yajin} será devolvida no final do aluguer",
    tips_2:
      "Recarregue a caução de {currencyName}{yajin} para usar no aluguer, e quando terminar pode ser reembolsada",
    tips_3:
      "O saldo atual é {currencyName}{myyue}, que pode ser usado diretamente para aluguer",
    submit: "Iniciar aluguer",
    borrow: "Alugar",
    msg_fail_title: "Erro",
    msg_fail_content: "Falha no aluguer, por favor tente novamente",
    msg_rentcount: "Tem {zujieNum} encomendas não fechadas",
    goborrow: "Ir carregar!!!",
    nearby: "Ver estações próximas",
    preauth: "Pré-autorização",
    nearbyvenues: "Locais próximos",
    borrow_tips: "Segurança do pagamento com cartão de crédito/Declaração de privacidade/Condições de uso",
    company_address: "Muamera Onerbegovica 3, 71000 Sarajevo",
    company_phone: "0038762701640",
    company_email: "info@chargi.ba",
    company_id: "ID Broj: 4203351730008",
    company_vat: "PDV broj: 203351730008",
    company_name: "ITGen d.o.o"
  },
  login: {
    welcome: "Bem-vindo ao {appname}",
    code_title: "verificação",
    phone_number: "Número de telefone",
    verification_email: "Por favor insira o seu endereço de e-mail",
    verification_code: "Por favor insira o código de verificação",
    captcha_code: "Código",
    send_code: "Enviar código",
    login: "Entrar",
    agree: "Ao clicar em Entrar, concorda com ",
    readme: "Termos de Utilização",
    msg_fail_login: "Falha no login",
    msg_success_login: "Login bem-sucedido",
    msg_fail_user: "Erro ao obter informações do utilizador. Deseja tentar novamente?",
    sign_in_with: "Entrar com",
    no_sms: "Não recebeu a mensagem de texto",
    retry: "Reenviar",
    email: "E-mail",
    phone_format_tips: "Formato de telefone incorreto"
  },
  confirm: {
    deletecard: "Eliminar cartão",
    addcard: "Introduzir dados do cartão",
    title: "Confirmação de pagamento",
    paynow: "Pagamento imediato",
    SMSConfirm:
      "Por favor pague de acordo com a mensagem de texto recebida no seu telemóvel e clique no botão de confirmação para continuar.",
    pay_label: "Valor",
    auth_label: "Pré-autorização",
    price_tips:
      "O seu saldo pode ser retirado se solicitado. Pode demorar 1-5 dias úteis a aparecer na sua conta de pagamento.",
    auth_tips:
      "É obrigatório um valor de pré-autorização de {0}{1}. O valor real do aluguer será deduzido quando o power bank for devolvido.",
    pay_type: "Por favor selecione o seu método de pagamento preferido",
    submit: "Confirmar pagamento",
    msg_loading: "A carregar...",
    msg_fail_title: "Aviso",
    msg_fail_payment: "Falha ao iniciar o pagamento da caução",
    msg_fail_order: "Falha ao criar a encomenda de aluguer",
    msg_fail_support: "O sistema não é suportado",
    msg_fail_confirm: "Confirmar",
    msg_fail_retry: "Tentar novamente",
    msg_fail_cancel: "Cancelar",
    payment_agreement: "Concordo e aceito os termos de compra",
    payment_agreement_tips: "Por favor marque para concordar com os termos de compra",
    mtn_mobile_number: "Número de telemóvel MTN",
    mtn_mobile_number_tips: "Por favor insira o número de telemóvel MTN",
    payment_confirmation: "Confirmação de pagamento",
    payment_confirmation_tips: "Por favor confirme que completou o processo de pagamento?",
    mbway_tips: "Por favor aprove o pagamento na sua app MB WAY",
    balance_pay_tips:
      "O seu saldo é suficiente para a caução. Confirme para alugar com o saldo da carteira.",
    unpaid: 'Não pago',
    paid: 'Pago'
  },
  mine: {
    title: "Perfil do Utilizador",
    wallet: "A minha Carteira",
    balance: "O meu Saldo",
    deposit: "Caução",
    wallet_in: "Carregar",
    wallet_out: "Levantar",
    wallet_log: "Registo da Carteira",
    rental_history: "Histórico de Alugueres",
    payment_title: "Métodos de Pagamento",
    download_app: "Descarregar a aplicação",
    settings: "Definições",
    help: "Ajuda",
    logout: "Terminar sessão",
    login_tips: "Por favor inicie sessão",
    msg_fail_title: "Erro",
    msg_fail_update: "Falha na modificação. Por favor tente novamente",
    msg_loading: "A carregar...",
    msg_fail_user: "Erro ao obter informações do utilizador. Deseja tentar novamente?",
    edit_profile: "Editar Perfil",
    join_us: "Junte-se a nós",
    join_us_details: "Obtenha uma estação Blitz no seu espaço"
  },
  msg: {
    appoffline: "A aplicação ainda não foi lançada, por favor aguarde",
    deletecard: "Tem a certeza que deseja eliminar este cartão?",
    no_phone: "É necessário número de telefone",
    loading: "A carregar...",
    title: "Sugestão",
    success: "Operação Bem-sucedida",
    error: "Erro desconhecido. Por favor tente novamente mais tarde",
    roleerror: "Permissões insuficientes. Por favor consulte o administrador.",
    neterror: "Falha na ligação à rede. Por favor tente novamente mais tarde",
    confirm: "Confirmar",
    retry: "Tentar novamente",
    cancel: "Cancelar",
    title_fail: "Aviso",
    vieworder: "Ver encomenda",
    success_payment: "Pagamento concluído",
    success_buy: "Compra concluída",
    fail_payment: "Falha no pagamento",
    keyword: "Palavra-chave",
    ispayorder: "Por favor confirme se o pagamento foi efetuado",
    unpay: "Não pago",
    yespay: "Pago",
    notopen: "Ainda não aberto"
  },
  result: {
    tips:
      "Para ver encomendas e outros locais de estações, por favor descarregue a aplicação.",
    download: "Descarregar a aplicação",
    title: "Aluguer confirmado",
    gotit: "Entendido",
    price_plan: "Tarifa de Carregamento",
    msg_success: "Alugado com Sucesso",
    msg_tips_loading:
      "O power bank está a ser ejetado, por favor aguarde..",
    msg_result_loading: "O resultado do pagamento está a ser confirmado...",
    msg_fail_confirm: "Confirmar",
    btn_usage: "Nota de utilização",
    btn_return: "Nota de devolução",
    deposit: "Caução",
    msg_fail_content: "Pedido falhou. Por favor tente novamente.",
    price_label: "por hora",
    price_info:
      "Grátis para os primeiros {mianfei} minutos, máximo de {ccurrency}{fengding} por dia. A caução será automaticamente deduzida quando o aluguer atingir {ccurrency}{yajin}",
    tips_1:
      "Por favor retire o power bank Nr.{number} como mostrado na imagem",
    tips_2:
      "Por favor organize os cabos e insira o power bank na ranhura com o lado marcado com [setas para baixo]",
    msg_note_usage:
      "O power bank está equipado com 3 tipos de cabos, por favor escolha o necessário para o seu dispositivo.",
    msg_note_return:
      "Por favor organize os cabos e insira o power bank na ranhura com o lado marcado com [setas para baixo]",
    return_info:
      "Ao devolver, certifique-se de que os cabos estão bem organizados e insira o lado com contactos metálicos numa ranhura disponível até ao fundo e estabilizar.",
    download_tips: "Para alugar o nosso powerbank, pode escolher uma das seguintes opções"
  },
  result_msg: {
    loading: "A carregar...",
    refresh: "Atualizar"
  },
  order: {
    title: "Histórico de Alugueres",
    in_use: "Em Uso",
    ended: "Terminado",
    msg_error: "Pedido falhou",
    order_number: "Nr.",
    order_details: "Detalhes da Encomenda",
    order_zj_shop: "Local de aluguer",
    order_zj_time: "Hora de aluguer",
    order_gh_shop: "Local de devolução",
    order_gh_time: "Hora de devolução",
    order_use_time: "Tempo de Uso",
    order_amount: "Valor total",
    not_on_rent: "Não está alugado",
    "renting": "No aluguer",
    "undone": "Por fazer",
    "returned": "Devolvido",
    "questions": "Questões",
    "timeout_to_return": "Tempo limite para devolver",
    "suspended_for_billing": "Suspenso para faturação"
  },
  order_item: {
    order_number: "Nr.",
    venue_rented: "Local de recolha",
    time_rented: "Hora de recolha",
    venue_returned: "Local de devolução",
    time_returned: "Hora de devolução",
    charge_standard: "Tarifa de carregamento",
    charge_standard_info:
      "{pJifei} {pCurrency} por hora (primeiros {pMian} mins gratuitos)",
    rent_occurred: "Aluguer ocorreu",
    returned: "Devolvido",
    unreturned: "Não devolvido",
    type_0: "Não Completo",
    type_1: "Em Aluguer",
    type_2: "Cancelado",
    type_3: "Devolvido",
    type_4: "Ocorreu um erro",
    type_5: "Excesso de tempo",
    min: "Min",
    payment: "Pagamento",
    unpay: "Não pago"
  },
  setting: {
    title: "Definições",
    lang: "Idioma"
  },
  help: {
    title: "FAQ",
    rentals: "Alugueres",
    venues: "Locais",
    payments: "Pagamentos"
  },
  wallet_in: {
    title: "Recarregar Saldo",
    price_label: "Valor de recarga",
    price_placeholder: "Por favor insira o valor de recarga",
    balance: "Saldo atual",
    price_auto: "Escolher Valor de Pagamento",
    price_tips:
      "O seu saldo pode ser levantado a seu pedido. Pode demorar 1-5 dias úteis a aparecer na sua conta de pagamento.",
    submit: "Submeter",
    loading: "A carregar...",
    paying: "A redirecionar para a página de pagamento..",
    msg_title: "Sugestões",
    msg_fail_order: "Falha ao criar a encomenda de recarga",
    msg_fail_payment: "Falha ao iniciar o pagamento de recarga",
    msg_fail_retry: "Tentar novamente"
  },
  wallet_out: {
    title: "Levantamento",
    price_label: "Valor de levantamento",
    price_placeholder: "Por favor insira o valor de levantamento",
    balance: "Saldo atual",
    balance_all: "Levantar tudo",
    deposit: "Caução",
    deposit_tips:
      "Existe uma encomenda de aluguer pendente. A caução de Ksh{pyajin} não é reembolsável",
    submit: "Submeter",
    apply: "Aplicar",
    confirm: "Confirmar",
    loading: "A carregar...",
    msg_fail_price: "O valor de levantamento está incorreto",
    msg_fail_balance:
      "O valor de levantamento não pode exceder o saldo atual",
    msg_fail_submit: "Por favor preencha todas as informações necessárias",
    msg_title: "Erro",
    msg_success_content: "Reembolso Bem-sucedido",
    confirmtitle: "Sugestões",
    confirmcontent:
      "A carteira atual não suporta levantamento em dinheiro. Por favor registe as suas informações de contacto para processamento manual de reembolso",
    payee_name: "Nome do Beneficiario",
    payee_bankcard: "Número do cartão bancário",
    payee_phone: "Telefone",
    cancelText: "Cancelar",
    confirmText: "Candidatar novamente"
  },
  map: {
    在线: "Aberto",
    离线: "Fechado",
    title: "Estação Próxima",
    result_msg: "Não foi encontrada nenhuma estação nas proximidades",
    msg_title: "erro",
    no_support: "Desculpe! O seu navegador não suporta serviços de localização",
    my_position: "A Minha Localização",
    distance: "Distância:",
    shop_time: "Horas",
    free: "Disponível para Aluguer",
    return: "Ranhuras vazias disponíveis",
    shop_title: "Detalhes do local",
    address: "Morada",
    go_here: "Ir aqui",
    nav_help: "Ajuda",
    nav_search: "Pesquisar",
    locate: "Localizar"
  },
  scanQr: {
    NotAllowedError: 'É necessário permitir o acesso à câmara',
    NotFoundError: 'Não existe câmara neste dispositivo',
    NotSupportedError: 'Contexto de segurança necessário (HTTPS, localhost)',
    NotReadableError: 'A câmara está em uso',
    OverconstrainedError: 'A instalação da câmara não é adequada',
    StreamApiNotSupportedError: 'Este navegador não suporta a API de streaming'
  },
  payment: {
    payment_title: "Métodos de Pagamento",
    pay_type: "Por favor adicione os dados do seu cartão",
    add_payment_card: "Adicionar Cartão de Pagamento",
    add_payment: "adicionar pagamento"
  },
  shop: {
    title: "Estação Próxima",
    search_station: "Pesquisar uma estação",
    search_station_tips: "Por favor insira o nome da estação",
    shop_power_banks: "Power Banks",
    shop_empty_slots: "Ranhuras Vazias",
    shop_address: "Morada",
    shop_business_hours: "Horário de Funcionamento",
    shop_directions_station: "Obter direções para a estação",
    shop_scan_qrcode: "Ler código QR"
  },
  time: {
    days: "Dias",
    hours: "Horas",
    minutes: "Minutos"
  }
};
